import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from "highcharts/highcharts-more.js";
import solidGauge from "highcharts/modules/solid-gauge.js";

highchartsMore(Highcharts);
solidGauge(Highcharts);

export function SolidGauge({ isLoading, indicador, title, color }) {
  const { t } = useTranslation();
  if (isLoading) {
    return (
      <Box height={280} width="100%">
        <Skeleton
          height="100%"
          style={{
            backgroundColor: '#adadad',
          }}
          variant="rectangular"
        />
      </Box>
    );
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'solidgauge',
          height: 280,
        },
        title: {
          text: title,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true,
              color: '#66788A',
            },
          },
        },
        pane: {
          center: ['50%', '75%'],
          size: '130%',
          startAngle: -90,
          endAngle: 90,
          background: {
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'arc',
          },
        },
        xAxis: {
          categories: ['nada'],
          labels: {
            rotation: -45,
            enabled: true,
          },
          title: {
            text: null,
          },
          gridLineWidth: 0,
        },
        yAxis: [
          {
            labels: {
              enabled: false,
              rotation: 'auto',
              style: {
                color: '#FFF',
              },
            },
            min: 0,
            max: 100,
            stops: [
              [0, color], // red
              [1, color], // green
            ],
          },
        ],
        series: [
          {
            name: t('sync.availability.chart.label.indicator'),
            color: '#41B900',
            data: [indicador > 100 ? 100.0 : indicador],
            dataLabels: {
              format:
                '<div style="text-align:bottom">' +
                '<span style="font-size:25px">{y}</span>' +
                '<span style="font-size:12px;opacity:0.4">%</span>' +
                '</div>',
              style: {
                color: '#66788A',
              },
            },
          },
          {
            name: t('sync.availability.chart.label.indicator'),
            type: 'gauge',
            data: [indicador],
          },
        ],
      }}
    />
  );
}
